export class ForgetPasswordRequest {
    password: string;
    code: string;
  
    constructor(password: string, code: string) {
      this.password = password;
      this.code = code;
    }
  }
  